export default {
  SET_INPUT_VALUE(state, data) {
    state.inputValue = data;
  },

  SET_VESSELS(state, data) {
    state.vessels = data;
  },

  SET_PICTURES(state, data) {
    state.pictures = data;
  },

  SET_FREE_FILES(state, data) {
    state.freeFiles = data;
  },
};
